import React from 'react';
import l10n from "../../../l10n/localization";
import * as utilsFog from "../../../utils/fog";

export default class Compta extends React.Component {
    constructor(props) {
        super(props);
        this.state = utilsFog.fogToForm(this.props.fogs.getById(this.props.fog.id).original);
    }

    componentDidMount(){
        let comments = (this.state.comments)?this.state.comments:null;
        this.props.comptaUpdate(this.props.fogs,this.props.fog, comments,this.props.dispatch);
    }

    onChange = (event) => {
        this.props.handleChange();
        let nextState = this.state;
        nextState.comments = event.target.value;
        this.props.comptaUpdate(this.props.fogs,this.props.fog, this.state.comments,this.props.dispatch);
        this.setState({...this.state, nextState});
    };

    render() {
        let formClassName = (this.state.isDirty) ? 'department-form dirty':'department-form';

        return (
            <span className={formClassName}>
                <section className="form-group field field-object">
                    <h2 className="yellow-border">{l10n.fog.accountsDepartment}</h2>
                    <div className="content">
                        <div className="form-group field field-string">
                            <label className="control-label" htmlFor="root_comments">{l10n.fog.comments}</label>
                            <textarea style={{marginTop: "-15px"}} id="root_comments" className="form-control" placeholder="" rows="10" onChange={this.onChange} value={this.state.comments} />
                        </div>
                    </div>
                </section>
            </span>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/fog/costInvoice/Compta.js